var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:{open: _vm.isOpen}},[_c('span',{on:{"click":function($event){return _vm.$emit('mobile-side-nav-close')}}},[_vm._v(" × ")]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }